import React from "react";

const TargetIOrderIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#tb28sy1uua)">
        <path d="M20 20.222a2.222 2.222 0 1 0 0-4.444 2.222 2.222 0 0 0 0 4.444z" fill="#0BEC9F" />
        <path d="M20 24a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" stroke="#0BEC9F" strokeWidth="3" />
      </g>
      <defs>
        <filter
          id="tb28sy1uua"
          x="0"
          y="0"
          width="40"
          height="40"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="6" />
          <feColorMatrix values="0 0 0 0 0.0431373 0 0 0 0 0.92549 0 0 0 0 0.623529 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_563_160892" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_563_160892" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default TargetIOrderIcon;
